"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: ".6rem",
      fontWeight: "900",
      textTransform: "uppercase"
    },
    breadcrumbsSeparator: {
      fontSize: "1rem"
    }
  };
};

exports.styles = styles;